<ion-item class="ion-align-items-start product" [routerLink]="['/main/products/detail/', product.productkey]">
  <ion-thumbnail *ngIf="product.productimage" style="height: 25vw; width:25vw; max-height: 120px; max-width: 120px; --border-radius:7px;" slot="start">
    <ion-img [src]="'https://cmh-test.web02.mybusiness.nl/api' + product.productimage"></ion-img>
  </ion-thumbnail>
  <ion-label>
    <h3 style="white-space: normal; font-size: 10px;">{{'sa_productkey_label' | translate}} {{product.productkey}}</h3>
    <h2 style="white-space: normal; font-size: 14px; font-weight: 600;" [innerHTML]="product.productname"></h2>
    <h4 style="white-space: normal; font-size: 12px;">
      <div style="line-height: 2em;">
        <ion-icon style="font-size: 16px; margin-right: 2px; margin-bottom: -5px;" src="assets/fa-light/warehouse-alt.svg"></ion-icon> {{'sa_product_item_bulk_stock' | translate}} {{getBulkStock() === 0 ? '0' : getBulkStock()}}
      </div>
      <div style="line-height: 2em;">
        <ion-icon style="font-size: 16px; margin-right: 2px; margin-bottom: -5px;" src="assets/fa-light/coin.svg"></ion-icon> {{'sa_fromamount_label' | translate}} {{salesPrice | currency:'EUR'}}
      </div>
    </h4>
    <div style="display: flex; gap: 10px !important;">
      <ion-badge *ngIf="product?.productproperty12" color="tertiary">
        {{'sa_product_bchoice_badge' | translate}}
      </ion-badge>
      <ion-badge *ngIf="product?.productproperty20" color="tertiary">
        {{'sa_product_restriction_badge' | translate}}
      </ion-badge>
    </div>
  </ion-label>
  <div style="position: absolute; top: 7px; right: 7px;">
    <ion-badge style="align-self: center;" *ngIf="product.discount">
      {{product?.discount?.discountname || ('sa_discount_label' | translate)}}
    </ion-badge>
    <ion-badge style="align-self: center;" *ngIf="!product.discount && discountName">
      {{discountName}}
    </ion-badge>
  </div>
</ion-item>